import * as ss from 'superstruct';
import { Id } from '../../types';
import { ConversionResource } from '../conversion.resource';
import { FilterParams, IsDefined, IsEmpty } from '../../../params';
import { ConversionFilter } from './conversion-filter';

export const ConversionFilterListResource = ss.object({
  id: Id,
  name: ss.string(),
  notes: ss.optional(ss.nullable(ss.string())),
  createdAt: ss.optional(ss.nullable(ss.date())),
  updatedAt: ss.optional(ss.nullable(ss.date())),
  /**
   * Merged in order. Last one wins if there is a conflict.
   */
  filters: ss.array(ss.object()), // ConversionFilter
});

export type ConversionFilterListResource = ss.Infer<
  typeof ConversionFilterListResource
>;

export const toFilterParams = (
  r: ConversionFilterListResource,
): FilterParams<ConversionResource> => {
  const ret: FilterParams<ConversionResource> = {};

  for (const filterRaw of r.filters) {
    // SAFETY: filters are written by the conversion filter list editor, which
    // saves ConversionFilter entries; the API only checks them as objects.
    const filter = filterRaw as ConversionFilter<keyof ConversionResource>;

    const rhs =
      filter.field === 'otherData'
        ? {
            [filter.subfield]: filter.value,
          }
        : filter.value;

    if (filter.comparison === 'eq') {
      // @ts-expect-error - types don't quite line up.
      ret[filter.field] = rhs;
    } else if (
      filter.comparison === IsDefined ||
      filter.comparison === IsEmpty
    ) {
      ret[filter.field] = filter.comparison;
    } else {
      // @ts-expect-error - types don't quite line up.
      ret[`${filter.field}_${filter.comparison}`] = rhs;
    }
  }

  return ret;
};
